import moment, { Moment } from "moment"

export const forceUTC = (date: Moment | Date) => {
  //this isnt the prettiest solution, but since @material-ui/pickers
  //forces us to use local dates in our code, we have no choice
  const inverseOffset = moment(date).utcOffset() * -1
  return moment.utc(date).utcOffset(inverseOffset, true)
}
